/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

import { OrderDetailsSummary } from 'shared-ui/components/OrderDetailsLayout';
import DetailSummary from './DetailSummary';
import { PassTypeProps, ReservationProps } from '../props';

/**
 * NOTE: This component is used by ui-widget. We will need to check ui-widget whenever we do a change here
 */
function ReservationSummary({
    isLoading,
    heading,
    imageUrl,
    parentName,
    proceedToCartButtonText,
    secondaryButtonText,
    isDrawerWrapFullWidth,
    passType,
    reservation,
    onProceedToCartClick,
    onSecondaryButtonClick,
}) {
    return (
        <OrderDetailsSummary
            isLoading={isLoading}
            heading={heading}
            imageUrl={imageUrl}
            parentName={parentName}
            proceedToCartButtonText={proceedToCartButtonText}
            secondaryButtonText={secondaryButtonText}
            isDrawerWrapFullWidth={isDrawerWrapFullWidth}
            onProceedToCartClick={onProceedToCartClick}
            onSecondaryButtonClick={onSecondaryButtonClick}
        >
            <DetailSummary
                facilityName={heading}
                passType={passType}
                reservation={reservation}
            />
        </OrderDetailsSummary>
    );
}

ReservationSummary.propTypes = {
    isLoading: PropTypes.bool,
    heading: PropTypes.string,
    imageUrl: PropTypes.string,
    parentName: PropTypes.string,
    proceedToCartButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    isDrawerWrapFullWidth: PropTypes.bool,
    passType: PassTypeProps,
    reservation: ReservationProps,
    onProceedToCartClick: PropTypes.func,
    onSecondaryButtonClick: PropTypes.func,
};

export default ReservationSummary;
